import React, { Component } from "react";
import { connect } from "react-redux";
import { authLogout } from "../../actions/authActions";
import { withRouter } from "react-router";
import LocationWatch from "./LocationWatch";

const HOME = [
  {
    title: "홈",
    pathname: "/"
  },
  {
    title: "명단 관리",
    pathname: "/users-manager"
  }
];

const QUIZ = [
  {
    title: "1단계",
    pathname: "/quiz1"
  },
  {
    title: "2단계",
    pathname: "/quiz2"
  },
  {
    title: "3단계",
    pathname: "/quiz3"
  },
  {
    title: "4단계",
    pathname: "/quiz4"
  },
  {
    title: "4단계 피드백",
    pathname: "/quiz4-feedback"
  }
];

const DEBATE = [
  {
    title: "사전 투표",
    pathname: "/early-voting"
  },
  {
    title: "시상 투표",
    pathname: "/awards"
  },
  {
    title: "피드백",
    pathname: "/feedback"
  },
  {
    title: "최종 투표",
    pathname: "/final-voting"
  }
];

class Nav extends Component {
  renderList = (list, location, history) =>
    list.map((l, idx) => (
      <div key={idx} className="my-2 d-flex">
        <button
          onClick={() => {
            history.push(l.pathname);
          }}
          className={
            location.pathname === l.pathname
              ? "btn btn-sm btn-block btn-outline-info"
              : "btn btn-sm btn-block btn-outline-secondary"
          }
          style={{ cursor: "pointer" }}
        >
          {l.title}
        </button>
        {/* TODO: MARKING FROM DB */}
        {/* {list === DEBATE && (
          <div className="ml-2">
            <span class="badge badge-pill badge-warning">온에어</span>
          </div>
        )} */}
      </div>
    ));

  render() {
    const { location, history } = this.props;

    return (
      <>
        <LocationWatch />
        <div id="nav" className="row border-right">
          {/* <div className="col">{this.renderList(location, history)}</div> */}
          {/* HOME */}
          <div className="col-12 mb-3">
            {this.renderList(HOME, location, history)}
          </div>
          {/* QUIZ */}
          <div className="col-12 mb-3">
            <h6 className="text-center">퀴즈</h6>
            {this.renderList(QUIZ, location, history)}
          </div>
          {/* DEBATE */}
          <div className="col-12 mb-3">
            <h6 className="text-center">디베이트</h6>
            {this.renderList(DEBATE, location, history)}
          </div>
          {/* LOGOUT */}
          <div className="col-12 mb-3 text-center">
            <button
              className="text-danger bg-white"
              onClick={this.props.authLogout}
              style={{
                textDecoration: "underline",
                fontSize: "0.9rem",
                border: "none"
              }}
            >
              로그아웃
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    null,
    { authLogout }
  )(Nav)
);
